"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        id: 1,
        profileId: 1,
        type: "DRIVER" /* DRIVER */,
        userSub: 'fe3eb621-ba80-4c99-9a06-e1f5a76ce065',
    },
];
